<template>
  <div>
    <v-layout wrap style="min-height:100vh;">
      <v-flex sm4 pa-5 class="background">
        <v-container class="d-flex fill-height">
          <v-layout wrap>
            <v-flex xs12>
              <v-img src="@/assets/logo.png" max-width="300" style="margin:0 auto"></v-img>
              <br />
              <h2 style="text-align:center" class="white--text">EXPRESS035</h2>
            </v-flex>
            <v-flex xs12 class="d-flex align-center">
              <p class="headline white--text">GUIATS</p>
            </v-flex>
            <v-flex xs12 class="d-flex align-center">
              <p class="display-2 white--text">{{ user.orgName }}</p>
            </v-flex>
            <v-flex xs12 class="d-flex align-end justify-left">
              <v-flex class="white--text">
                <p class="subtitle">
                  <b>Contacto: {{ user.name }}</b>
                </p>
                <p>
                  <a :href="'tel:'+user.phone" class="white--text">{{ user.phone }}</a>
                </p>
                <p>
                  <a :href="'mailto:'+user.email" class="white--text">{{ user.email }}</a>
                </p>
              </v-flex>
            </v-flex>

            <v-flex xs12 class="d-flex align-end justify-left">
              <v-flex class="white--text">
                <p class="subtitle">Contacto</p>
                <p>
                  <a
                    class="white--text"
                    style="text-decoration:none"
                    href="tel:6641237179"
                  >664 123 71 79</a>
                </p>
                <p>
                  <a
                    class="white--text"
                    style="text-decoration:none"
                    href="mailto:promocionyventas@human-express.com"
                  >promocionyventas@human-express.com</a>
                </p>
                <p>
                  <a
                    class="white--text"
                    style="text-decoration:none"
                    href="http://human-express.com/"
                  >human-express.com</a>
                </p>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex
        sm8
        pa-5
        :class="{'d-flex': center,'align-center':center,primary:center}"
        class="primary"
      >
        <v-container grid-list-md>
          <div style="text-align:right">
            <v-btn @click="showHelp = true">Ayuda</v-btn>
          </div>
          <router-view></router-view>
        </v-container>
      </v-flex>
    </v-layout>

    <v-dialog v-model="showHelp" width="50%">
      <Help :hideExtra="true" @closeDialog="showHelp=false" />
    </v-dialog>

    <v-snackbar v-model="snackbar" top right>
      {{ message }}
      <v-btn color="pink" text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import Help from "./Help";
import axios from "axios";
export default {
  components: {
    Help
  },
  watch: {
    $route(to, from) {
      this.center = false;
    }
  },
  data() {
    return {
      showHelp: false,
      requiredRule: [v => !!v || "Este campo es obligatorio"],
      emailRule: [
        v => !!v || "Este campo es obligatorio",
        v => /.+@.+\..+/.test(v) || "El correo debe ser valido"
      ],
      email: "",
      password: "",
      snackbar: false,
      message: "",
      user: {},
      center: false,
      host: process.env.VUE_APP_HOST
    };
  },
  methods: {
    getData() {
      let idUser = this.$route.params.idUser;
      let path = this.$route.path;

      if (path.includes("login")) {
        this.center = true;
      }

      axios
        .get(this.host + "/questionnaire/readuser.php?idUser=" + idUser)
        .then(response => {
          this.user = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style scoped>
.background {
  background-image: url(../../assets/background.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-color: rgba(8, 5, 15, 0.8);
  opacity: 0.8;
}
</style>